import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { AuthingButton } from "../../../components/AuthingButton";
import "./styles.less";

export const OpenBanner = (props) => {
  const { t } = useTranslation();
  const { title, subtitle, btnUrl, btnName, link, linkName, bg, tag } = props;

  const downloadFile = (fileUrl, fileName) => {
    const iframe = document.createElement("iframe");
    iframe.src = fileUrl;
    iframe.style.display = "none";
    iframe.name = fileName;

    document.body.appendChild(iframe);
    return new Promise((resolve, reject) => {
      const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
      if (
        iframeDoc.readyState === "complete" ||
        iframeDoc.readyState === "interactive"
      ) {
        resolve(true);
      }
    });
  };
  return (
    <div
      className="open-detail-banner"
      style={{
        background: `url(${bg}) center center no-repeat`,
        backgroundSize: "cover",
      }}
    >
      <div
        className={
          tag === "b2e" ? "open-detail-mask light" : "open-detail-mask dark"
        }
      ></div>
      <div className="inner">
        <div className={tag === "b2e" ? "title light" : "title"}>{title}</div>
        <div className={tag === "b2e" ? "description light" : "description"}>
          {subtitle}
        </div>
        <AuthingButton
          style={{ marginRight: 24 }}
          onClick={() => {
            downloadFile(btnUrl, btnName);
          }}
        >
          {btnName}
        </AuthingButton>
        <AuthingButton
          onClick={() => {
            window.open(link);
          }}
          mode="light"
        >
          {linkName}
        </AuthingButton>
      </div>
    </div>
  );
};
